import { render, staticRenderFns } from "./ModuleInput.vue?vue&type=template&id=d884f52e&scoped=true"
import script from "./ModuleInput.vue?vue&type=script&lang=js"
export * from "./ModuleInput.vue?vue&type=script&lang=js"
import style0 from "./ModuleInput.vue?vue&type=style&index=0&id=d884f52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d884f52e",
  null
  
)

export default component.exports